import { AggregateRating, Thing } from 'schema-dts';

import I18n from '~/src/common/services/I18n';
import useGetReviews from '~/src/common/services/Trustpilot/useGetReviews';
import { GetCategory200Image } from '~/src/queries/api-ecom/generated/api-ecom.schemas';

import { IMAGE_TRANSFORM_CATEGORY } from './constants';
import Seo from './Seo';
import { getSeoImage } from './utils';

interface Props {
  metaCanonical?: string;
  metaDescription?: string;
  metaTitle?: string;
  noIndex?: boolean;
  image?: GetCategory200Image;
}

export const SeoHome = ({ metaDescription, metaTitle, metaCanonical, noIndex, image }: Props) => {
  const { data } = useGetReviews();
  const schemas: Thing[] | undefined = data?.score
    ? [
        {
          '@type': 'Organization',
          'aggregateRating': {
            '@type': 'AggregateRating',
            'ratingValue': String(data.score.trustScore),
            'reviewCount': String(data.numberOfReviews.total),
          } as AggregateRating,
        },
      ]
    : undefined;

  const seoImage = getSeoImage(image?.url, IMAGE_TRANSFORM_CATEGORY);

  return metaDescription && metaTitle ? (
    <Seo
      title={metaTitle}
      image={seoImage}
      noIndex={noIndex}
      metaDescr={metaDescription}
      canonicalUrl={metaCanonical ?? '/'}
      noSuffix
      schemas={schemas}
    />
  ) : (
    <Seo
      metaTitle={I18n.t('common.homepage')}
      metaDescr={I18n.t('home.meta-description')}
      canonicalUrl="/"
      noSuffix
    />
  );
};
